import { useState, useEffect } from "react";
import { KTIcon } from "../../../../_metronic/helpers";
import moment from "moment";
import { formatPrice } from "../../../../_metronic/helpers/utils";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const VoucherDetailsModal = ({
  setOpenVoucherDetailsModal,
  voucherDetails,
  setVoucherDetails,
  getVoucherDetials,
  isLoading
}) => {
  const [tab, setTab] = useState('list');

  useEffect(() => {
    document.body.classList.add("modal-open");

    return () => {
      document.body.classList.remove("modal-open");
    };
  }, []);

  const handleExport = () => {
    getVoucherDetials(voucherDetails[0].batch_id, true);
  }

  const copyVoucherCode = (code) => {
    navigator.clipboard.writeText(`${process.env.REACT_APP_API_CUSTOMER_URL}wallet/redemption-codes?gift-voucher=${window.btoa(code)}`);
    toast.success("Gift Voucher Link Copied");
  };

  return (
    <>
      <div
        className="modal fade show d-block"
        id="kt_modal_add_user"
        role="dialog"
        tabIndex={-1}
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered mw-850px">
          <div className="modal-content">
            <div className="modal-header py-3">
              <div>
                <h2 className="fw-bolder mb-0">Voucher Details</h2>
              </div>
              <div
                className="btn btn-icon btn-sm btn-active-icon-primary"
                data-kt-users-modal-action="close"
                onClick={() => {
                  setOpenVoucherDetailsModal(false);
                  setVoucherDetails(null);
                }}
                style={{ cursor: "pointer" }}
              >
                <KTIcon iconName="cross" className="fs-1" />
              </div>
            </div>
            <div className="modal-body scroll-y mx-5 mx-xl-5 my-2 p-4">
              <>
                <div className="kt_body">
                  <div className="nav-group nav-group-fluid mb-3 d-inline-block">
                    <label>
                      <input
                        type="radio"
                        className="btn-check"
                        name="tab"
                        checked={tab === 'list'}
                        onChange={() => {
                          setTab('list')
                        }}
                      />
                      <span className="btn btn-sm btn-active btn-active-primary fs-6 fw-bold">
                        List View
                      </span>
                    </label>
                    <label>
                      <input
                        type="radio"
                        className="btn-check"
                        name="tab"
                        checked={tab === 'grid'}
                        onChange={() => {
                          setTab('grid')
                        }}
                      />
                      <span className="btn btn-sm btn-active btn-active-primary px-4 fs-6 fw-bold">
                        Grid View
                      </span>
                    </label>
                  </div>
                  <div style={{ maxHeight: '310px', overflowY: `${tab === 'grid' ? 'auto' : 'hidden'}`, minHeight: 'auto', display: 'grid', gap: '10px', gridTemplateColumns: `${tab === 'grid' ? 'repeat(2, 1fr)' : '1fr'}` }}>
                    {
                      voucherDetails && voucherDetails.length > 0 ?
                        <>
                          {tab === 'list'
                            ? <List vouchers={voucherDetails} copyVoucherCode={copyVoucherCode} />
                            : <Grid vouchers={voucherDetails} copyVoucherCode={copyVoucherCode} />}
                        </>
                        :
                        <h4 className="text-center">No Vouchers details are Available</h4>
                    }
                  </div>
                  <div className="d-flex gap-2 mt-5 justify-content-center">
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={() => {
                        setOpenVoucherDetailsModal(false);
                        setVoucherDetails(null);
                      }}
                    >
                      Go Back
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm bg-success text-white"
                      disabled={isLoading}
                      onClick={handleExport}
                    >
                      Export Vouchers
                    </button>
                  </div>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export { VoucherDetailsModal };

export const Grid = ({ vouchers, copyVoucherCode }) => {
  return vouchers?.map((item, index) => {
    return (
      <div
        className="form-check form-check-custom form-check-solid d-flex justify-content-between align-items-center flex-wrap p-5 rounded-2"
        key={index}
        style={{
          background: (item.redeemed_at || moment(item.end_date).isSameOrBefore(moment())) ? '#f9f9f9' : "#e3feee9e",
        }}
      >
        <div className="fv-row w-50">
          <label className="fw-bold fs-6 mb-2 d-flex align-items-center gap-2">Voucher Code 
          {!item.redeemed_by_uid && <span className="badge badge-main fw-bold fs-7 p-1.5 pointer text-white"
          onClick={() => copyVoucherCode(item.code)}>
          Copy
          </span>
          }
          </label>
          <h5 className="fw-bolder text-main">{item.code}</h5>
        </div>
        <div className="fv-row w-50 text-end">
          <label className="fw-bold fs-6 mb-2">Amount</label>
          <h5 className="fw-bolder text-main">{formatPrice(item.amount)}</h5>
        </div>
        <div className="fv-row w-50">
          <label className="fw-bold fs-6 mb-2">Start Date</label>
          <h5 className="fw-bolder text-main">{moment(item.start_date).format("YYYY-MM-DD")}</h5>
        </div>
        <div className="fv-row w-50 text-end">
          <label className="fw-bold fs-6 mb-2">Expiration Date</label>
          <h5 className="fw-bolder text-main">{moment(item.end_date).format("YYYY-MM-DD")}</h5>
        </div>
        <div className="fv-row w-50">
          <label className="fw-bold fs-6 mb-2">Redeemed on</label>
          <div>
            <h5 className="fw-bolder text-main">{item.redeemed_at ? moment(item.redeemed_at).format("YYYY-MM-DD") : "-"}</h5>
          </div>
        </div>
        <div className="fv-row w-50 text-end">
          <label className="fw-bold fs-6 mb-2">Redeemed By</label>
            {item.redeemed_by_uid ? 
            <Link to={`/users/${item.redeemed_by_uid}`} className="fw-bolder d-block">{item.redeemed_by_name?.trim()}</Link>
              :
              <h5 className="fw-bolder text-main">-</h5>
            }
        </div>
         <div className="fv-row w-50">
          <label className="fw-bold fs-6 mb-2">Created At</label>
          <h5 className="fw-bolder text-main">{moment(item.created_at).utc().format("YYYY-MM-DD")}</h5>
        </div>
        <div className="fv-row w-50 text-end">
          <label className="fw-bold fs-6 mb-2">Created By</label>
          <h5 className="fw-bolder text-main">{item.created_by_name || "-"}</h5>
        </div>
        <div className="fv-row w-50">
          <label className="fw-bold fs-6 mb-2">Status</label>
          <h5 className="fw-bolder" style={{ color: (item.redeemed_at || moment(item.end_date).isSameOrBefore(moment())) ? '#ed2626' : '#2ecc71'}}>
            {item.redeemed_at ? "Redeemed" : moment(item.end_date).isSameOrBefore(moment()) ? "Expired" : "Active"}
          </h5>
        </div>
      </div>
    )
  })
}

export const List = ({ vouchers, copyVoucherCode }) => {

  const headers = [
    { title: 'Voucher Code', width: '130px' },
    { title: 'Start Date', width: '120px' },
    { title: 'Expiration Date', width: '130px' },
    { title: 'Amount', width: '100px' },
    { title: 'Redeemed On', width: '120px' },
    { title: 'Redeemed By', width: '130px' },
    { title: 'Status', width: '120px' },
    { title: 'Created At', width: '120px' },
    { title: 'Created By', width: '130px' },
  ]

  return (
    <div className='table-responsive' style={{ height: '320px' }}>
      <table
        id='kt_table_users'
        className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
      >
        <thead>
          <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
            {headers.map(column => (
              <th
                key={column.title}
                className={column.className}
                style={{ minWidth: column.width }}
              >
                {column.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className='text-gray-600 fw-bold'>
          {vouchers?.length > 0 && (
            vouchers.map(row => (
              <tr key={row.arrear_id}>
                <td style={{ minWidth: headers[0].width }}>
                <div className="d-flex align-items-center gap-1">
                {row.code}
                {!row.redeemed_by_uid && <span className="pointer"
                onClick={() => copyVoucherCode(row.code)}>
                &#9875;
                </span>
                }
                </div>
                </td>
                <td style={{ minWidth: headers[1].width }}>{moment(row.start_date).format("YYYY-MM-DD")}</td>
                <td style={{ minWidth: headers[2].width }}>{moment(row.end_date).format("YYYY-MM-DD")}</td>
                <td style={{ minWidth: headers[3].width }}>{formatPrice(row.amount)}</td>
                <td style={{ minWidth: headers[4].width }}>{row.redeemed_at ? moment(row.redeemed_at).format("YYYY-MM-DD") : "-"}</td>
                <td style={{ minWidth: headers[5].width }}>
                {row.redeemed_by_uid ? 
                <Link to={`/users/${row.redeemed_by_uid}`} className="fw-bolder d-block">{row.redeemed_by_name?.trim()}</Link>
                :
                '-'
                }
                </td>
                <td style={{ minWidth: headers[6].width, color: (row.redeemed_at || moment(row.end_date).isSameOrBefore(moment())) ? '#ed2626' : '#2ecc71'}}>
                {row.redeemed_at ? "Redeemed" : moment(row.end_date).isSameOrBefore(moment()) ? "Expired" : "Active"}
                </td>
                <td style={{ minWidth: headers[7].width }}>{moment(row.created_at).utc().format("YYYY-MM-DD") || "-"}</td>
                <td style={{ minWidth: headers[8].width }}>{row.created_by_name || "-"}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  )
}